import { Map, OrderedSet } from 'immutable';

import * as constants from './constants';
import * as types from './types';
import { GET_ORGANIZATION } from './../general/types';
import { getFilterPayloadAdapter } from './../../api-adapter';

const initialState = new Map({
  selectedDateFilter: new Map({
    type: 'relative',
    value: 7 * 24 * 60 * 60,
  }),
  errors: new Map({
    getTests: null,
    getOrganization: null,
    getMetrics: null,
  }),
  filters: new Map().withMutations((map) => {
    constants.FILTERS_MAP.mapKeys((key) => {
      map.set(key, new Map({
        items: new OrderedSet(),
        selectedItems: new OrderedSet(),
      }));
    });
  }),
});

const filtersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CLEAR_SELECTED_FILTERS:
      return state.update('filters', (filtersValue) => (
        filtersValue.map((filter) => filter.set('selectedItems', new OrderedSet()))
      )).set('selectedDateFilter', new Map({
        type: 'relative',
        value: 7 * 24 * 60 * 60,
      }));
    case types.SELECT_FILTER_ITEMS:
      return state.setIn(['filters', payload.name, 'selectedItems'], payload.items);
    case types.SELECT_DATE_FILTER:
      return state.set('selectedDateFilter', payload);
    case types.SET_FILTER_ITEMS:
      return state.setIn(['filters', payload.name, 'items'], payload.items);
    case types.REMOVE_FILTER_ITEM:
      return state.updateIn(['filters', payload.name, 'selectedItems'], (items) => (
        items.remove(payload.value)
      ));
    case types.SET_FILTERS_FROM_QUERY_PARAMS:
      return state.withMutations((newState) => {
        Object.entries(payload).forEach(([key, value]) => {
          if (!state.get('filters').has(key)) {
            return;
          }

          const valueArr = Array.isArray(value) ? value : [value];

          newState
            .updateIn(['filters', key, 'items'], (items) => items.union(valueArr))
            .updateIn(['filters', key, 'selectedItems'], (items) => items.union(valueArr));
        });
      });
    case types.GET_FILTERS.REQUEST:
      return state;
    case types.GET_FILTERS.SUCCESS:
      return state.withMutations((newState) => {
        Object
          .entries(getFilterPayloadAdapter(payload.aggs))
          .forEach(([key, items]) => {
            newState.setIn(
              ['filters', key, 'items'],
              // filter out all items that are empty strings or null/undefined
              new OrderedSet(items.map((item) => item.name).filter((item) => !!item)),
            );
          });
      });
    case types.GET_FILTERS.FAILURE:
      // skipping this error for now as it does not prevent user from anything,
      // just fails to narrow down the possible options
      return state;
    case GET_ORGANIZATION.SUCCESS:
      return state.updateIn(['filters', 'owners', 'items'], (items) => {
        let newItems = new OrderedSet();

        if (payload.is_ancestor) {
          newItems = newItems.add('Organization');
        }

        return newItems.union(items).union(payload.users);
      });
    default:
      return state;
  }
};

export default filtersReducer;
export { initialState };
